import { CalculationErrorMetadataInterface } from '../interfaces/calculation-error-metadata.interface';
import { CalculationErrorKeynameEnum } from '../enums/calculations/calculation-error-keyname.enum';

export const calculationErrorMetadata: { [id: string]: CalculationErrorMetadataInterface } = {
  [CalculationErrorKeynameEnum.Section84_1DivisionByZeroSinceTotalIncreasePaidUpCapitalForClassCalculusEquals0]: {
    i18n: {
      fr: 'La valeur totale du gain en capital ne peut être zéro.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.Section84_1DivisionByZeroWithTotalNumberOfSharesInClassEquals0]: {
    i18n: {
      fr: 'Le nombre total d\'actions d\'une classe ne peut être zéro.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.Section84_1DivisionByZeroWithTotalFairMarketValueOfSharesIssuedEquals0]: {
    i18n: {
      fr: 'La juste valeur marchande totale ne peut être zéro.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.Section84_1FairMarketValueOnValuationDayOfTransferredSharesUndefined]: {
    i18n: {
      fr: 'La juste valeur marchande des actions au jour de l\'évaluation n\'est pas définie.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.Section84_1ActualCostOnJanuary1972OfTransferredSharesUndefined]: {
    i18n: {
      fr: 'Le coût effectif des actions au 1er janvier 1972 n\'est pas défini.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.Section84_1ReceivedDividendChoice83OnTransferredSharesUndefined]: {
    i18n: {
      fr: 'Les dividendes reçus sur lesquels le choix du paragraphe 83(1) a été effectué ne sont pas définis.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.Section84_1PaidUpCapitalOfGiftedSharesUndefined]: {
    i18n: {
      fr: 'Le capital versé des actions cédées n\'est pas défini.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.Section84_1CapitalGainsOnTheShareDeclaredAfter1984Undefined]: {
    i18n: {
      fr: 'Les gains en capital qui ont donné droit à la DGC ne sont pas définis.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.Section84_1ReducedPaidUpCapitalUndefined]: {
    i18n: {
      fr: 'La réduction du capital versé n\'est pas définie.',
      en: '',
    },
  },

  [CalculationErrorKeynameEnum.RolloverDivisionByZeroWithCapitalCostOfAllThePropertiesEquals0]: {
    i18n: {
      fr: 'Le cout en capital de tous les biens de la catégorie qui n\'ont pas été disposés avant ce moment ne peut pas être zéro.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverDivisionByZeroWithFairMarketValueForPreferredSharesEquals0]: {
    i18n: {
      fr: 'La juste valeur marchande de cette catégorie d\'actions privilégiées ne peut pas être zéro.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverDivisionByZeroWithTotalNumberOfCommonSharesEquals0]: {
    i18n: {
      fr: 'Le nombre total d\'actions ordinaires pour ce bien transféré ne peut pas être zéro.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverDivisionByZeroWithFairMarketValueForCommonSharesEquals0]: {
    i18n: {
      fr: 'Le juste valeur marchande d\'actions ordinaires pour ce bien transféré ne peut pas être zéro.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverDivisionByZeroWithTotalFairMarketValueOfSharesEquals0]: {
    i18n: {
      fr: 'Le juste valeur marchande des actions pour ce bien transféré ne peut pas être zéro.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverDivisionByZeroWithNumberOfSharesAfterIssuanceEquals0]: {
    i18n: {
      fr: 'Le nombre d\'actions après l\'émission pour ce bien transféré ne peut pas être zéro.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverSellerIsMissing]: {
    i18n: {
      fr: 'Le vendeur n\'existe pas.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverTooManySellers]: {
    i18n: {
      fr: 'Le nombre de vendeurs excède le nombre maximal de vendeur (1).',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverNegativeResidualNonShareConsideration]: {
    i18n: {
      fr: 'La contrepartie autre qu\'en actions calculée est inférieure aux contreparties autres qu\'en actions demandées.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverTooManyNonShareConsiderationBilletAPayer]: {
    i18n: {
      fr: 'Il y a plusieurs contreparties autres qu\'en actions appelées Billet à payer.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAgreedAmountExceedsFairMarketValue]: {
    i18n: {
      fr: 'La somme convenue du bien ne peut excéder la juste valeur marchande.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAgreedAmountExceededByMinimumBetweenFairMarketValueAndCostAmountAndNonShareConsideration]: {
    i18n: {
      fr: 'La somme convenue du bien ne peut être plus petite que le minimum entre la juste valeur marchande, le coût indiqué et la contrepartie autre qu\'en actions.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverPaidUpCapitalOfTransferredSharesUndefined]: {
    i18n: {
      fr: 'Le capital versé des actions cédées n\'est pas défini.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverIsSameSharesConditionsTrueWhenIsInternalRolloverTrue]: {
    i18n: {
      fr: 'Le roulement ne pourrait pas fonctionner parce qu\'il y a un risque qu\'il n\'y ait pas eu de disposition dû aux mêmes privilèges, droits, conditions, restrictions des actions cédées et reçues.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverReducedPaidUpCapitalElementBInSection84_1Undefined]: {
    i18n: {
      fr: 'Le capital versé élément B n\'est pas défini.',
      en: 'Reduced Paid Up Capital Element B is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.RolloverReducedPaidUpCapitalInSection84_1Undefined]: {
    i18n: {
      fr: 'Le capital versé n\'Est pas défini.',
      en: 'Reduced Paid Up Capital is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.RolloverUnderpreciatedCapitalCostAfterAdditionsAndDispositionsUndefined]: {
    i18n: {
      fr: 'La FNACC du bien n\'est pas définie.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverIsRealEstateTrueAndIsNonResidentTrue]: {
    i18n: {
      fr: 'Le bien n\'est pas un bien admissible parce qu\'ils s\'agit d\'un bien immeuble détenu par un non résident.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverIsCustomerAccountTrueAndIsCashAccountingTrue]: {
    i18n: {
      fr: 'Le bien n\'est pas un bien admissible parce qu\'il s\'agit d\'un compte client et l\'entreprise calcule son revenu selon la méthode de la comptabilité de caisse.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverIsCustomerAccountTrueAndIsArticle22True]: {
    i18n: {
      fr: 'Le bien n\'est pas un bien admissible parce qu\'il s\'agit d\'un compte client dont le choix de l\'article 22 a été effectué.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverIsInventoryPropertyTrueAndIsRealEstateTrue]: {
    i18n: {
      fr: 'Le bien n\'est pas un bien admissible parce qu\'il s\'agit d\'un bien immeuble en inventaire.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverCapitalCostOfAllPropertiesUndefined]: {
    i18n: {
      fr: 'Le cout en capital de tous les biens de la catégorie qui n\'ont pas été disposés avant ce moment n\'est pas défini.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAtLeastTwoShareClassesWithSameId]: {
    i18n: {
      fr: 'Il y au moins deux fois la même catégorie d\'actions.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverShareClassMissing]: {
    i18n: {
      fr: 'La catégorie d\'actions n\'existe pas.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAtLeastTwoPreferredShareClassesWithSameID]: {
    i18n: {
      fr: 'Il y au moins deux fois la même catégorie d\'actions.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAtLeastTwoCommonShareClassesWithSameID]: {
    i18n: {
      fr: 'Il y au moins deux fois la même catégorie d\'actions.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAtLeastTwoNonShareConsiderationsWithSameId]: {
    i18n: {
      fr: 'Il y au moins deux fois la même contrepartie autre qu\'en actions.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverWhenIsCalculateNumberOfPreferredSharesTruePreferredShareClassMissing]: {
    i18n: {
      fr: 'Il n\'y a pas de catégorie d\'actions privilégiées.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverWhenIsCalculateNumberOfPreferredSharesTrueTooManyPreferredShareClasses]: {
    i18n: {
      fr: 'Le nombre de catégorie d\'actions privilégiées excède le nombre supposé (1).',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverFairMarketValueForNumberOfPreferredSharesNotAnIntegerWhenDividedBy100]: {
    i18n: {
      fr: 'Lorsque l\'option "Calculer le nombre d\'actions privilégiées" est activée, la juste valeur marchande ou la contrepartie autre qu\'en actions ne peut pas contenir des cents. Les valeurs doivent être des dollars entiers.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAtLeastTwoPropertiesTransferredWithSameId]: {
    i18n: {
      fr: 'Il y au moins deux biens transférés avec le même identifiant.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAtLeastTwoShareholdersWithSameId]: {
    i18n: {
      fr: 'Il y au moins deux actionnaires avec le même identifiant.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverWhenRedemptionValueIsUndefined]: {
    i18n: {
      fr: 'La valeur de rachat n\'est pas définie.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAtLeastOneShareClassWithAtLeastTwoShareClassesWithSameId]: {
    i18n: {
      fr: 'L\'objet contient au moins un élément pour lequel au moins deux catégories d\'actions auraient le même identifiant.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAtLeastOnePropertyTransferredWithAtLeastTwoPropertiesTransferredWithSameId]: {
    i18n: {
      fr: 'L\'objet contient au moins un élément pour lequel au moins deux biens transférés auraient le même identifiant.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAtLeastOneShareholderWithAtLeastTwoShareholdersWithSameId]: {
    i18n: {
      fr: 'L\'objet contient au moins un élément pour lequel au moins deux actionnaires auraient le même identifiant.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAtLeastOneShareClassWithAtLeastTwoShareClassesWithSameIdOrWithMissingId]: {
    i18n: {
      fr: 'L\'objet contient au moins un élément pour lequel au moins deux catégories d\'actions auraient le même identifiant ou pour lequel il manque cette catégorie d\'actions.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverDivisionByZeroWithNumberOfShares]: {
    i18n: {
      fr: 'Le nombre d\'actions ne peut pas être zéro.',
      en: '',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAgreedAmountUndefined]: {
    i18n: {
      fr: 'La somme convenue n\'est pas définie.',
      en: 'Agreed amount is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.RolloverAmountOfNonShareConsiderationInPropertyTransferredForNonShareConsiderationUndefined]: {
    i18n: {
      fr: 'La contrepartie autre qu\'en actions n\'est pas définie.',
      en: 'Non-share consideration is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.RolloverPropertyTransferredWhenPropertyTypeNotNonDepreciableAndAreSharesTrue]: {
    i18n: {
      fr: 'Le bien transféré ne peut pas être des actions puisqu\'il n\'est pas un bien non-amortissable.',
      en: 'The transferred property cannot be shares since it is not a non-depreciable property.',
    },
  },


  [CalculationErrorKeynameEnum.FSSMissingScenario]: {
    i18n: {
      fr: 'Le taux de cotisation au FSS doit correspondre à l\'un des scénarios ci-dessus.',
      en: 'The FSS Contribution Rate must be one of the scenarios above',
    },
  },
  [CalculationErrorKeynameEnum.FSSTotalPayrollForPrimarySectorUndefined]: {
    i18n: {
      fr: 'La masse salariale totale du secteur primaire est indéfinie.',
      en: 'The total payroll for primary sector is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.FSSCalculatePayrollRateForPrimarySectorDividedByZero]: {
    i18n: {
      fr: 'La masse salariale totale du secteur primaire est de 0. Ceci crée une division par 0..',
      en: 'The total payroll for primary sector is 0. This causes a division by 0..',
    },
  },
  [CalculationErrorKeynameEnum.Schedule8LineANotBetween0And12]: {
    i18n: {
      fr: 'La valeur entière de la ligne A n\'est pas valide. Elle est soit plus petite que 0, soit plus grande que 12.',
      en: 'The integer value in line A is not valid. It is either smaller than 0 or larger than 12.',
    },
  },
  [CalculationErrorKeynameEnum.Schedule8Line24IsUndefined]: {
    i18n: {
      fr: 'La ligne 24 n\'est pas définie.',
      en: 'Line 24 is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.Schedule8Line25IsUndefined]: {
    i18n: {
      fr: 'La ligne 25 n\'est pas définie.',
      en: 'Line 25 is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.Schedule8Line37IsUndefined]: {
    i18n: {
      fr: 'La ligne 37 n\'est pas définie.',
      en: 'Ligne 37 is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.Schedule8Line40IsUndefined]: {
    i18n: {
      fr: 'La ligne 40 n\'est pas définie.',
      en: 'Ligne 40 is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.Schedule8Line48IsUndefined]: {
    i18n: {
      fr: 'La ligne 48 n\'est pas définie.',
      en: 'Ligne 48 is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.Schedule8Line51IsUndefined]: {
    i18n: {
      fr: 'La ligne 51 n\'est pas définie.',
      en: 'Ligne 51 is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.Schedule8LineAIsLargerThan12]: {
    i18n: {
      fr: 'Le nombre de mois excède le nombre de mois de l\'année.',
      en: 'The number of months exceeds the number of months in the year.',
    },
  },
  [CalculationErrorKeynameEnum.Schedule8LineAIsSmallerThan1]: {
    i18n: {
      fr: 'Le nombre de mois est inférieur au minimum de 1.',
      en: 'The number of months is less than the minimum of 1.',
    },
  },
  [CalculationErrorKeynameEnum.Schedule8LineAIsNegative]: {
    i18n: {
      fr: 'Le nombre de mois est négatif.',
      en: 'The number of months is negative.',
    },
  },


  [CalculationErrorKeynameEnum.SchedulePAtLeastTwoChildrenWithSameId]: {
    i18n: {
      fr: 'Au moins deux enfants possèdent le même identifiant alors que chaque enfant doit avoir un identifiant unique.',
      en: 'At least two children share the same ID but each child should have a unique identifier.',
    },
  },
  [CalculationErrorKeynameEnum.SchedulePOptionsOfSpouseIsUndefinedWhenIsMarriedTrue]: {
    i18n: {
      fr: 'L\'objet des options de l\'époux n\'est pas définie alors que la personne principale est mariée.',
      en: 'The object of the spouse\'s options is not defined while the main person is married.',
    },
  },
  [CalculationErrorKeynameEnum.SchedulePAtLeastOneChildWithAtLeastTwoChildrenWithSameId]: {
    i18n: {
      fr: 'Au moins deux enfants possèdent le même identifiant alors que chaque enfant doit avoir un identifiant unique.',
      en: 'At least two children have the same ID but each child should have a unique identifier.',
    },
  },
  [CalculationErrorKeynameEnum.FiscalYearIsNotSupported]: {
    i18n: {
      fr: 'L\'année fiscale n\'est pas supportée.',
      en: 'Fiscal year is not supported.',
    },
  },
  [CalculationErrorKeynameEnum.FiscalYearIsNot2021]: {
    i18n: {
      fr: 'L\'année fiscale n\'est pas 2021.',
      en: 'Fiscal year is not 2021.',
    },
  },
  [CalculationErrorKeynameEnum.FiscalYearIsNot2023]: {
    i18n: {
      fr: 'L\'année fiscale n\'est pas 2023.',
      en: 'Fiscal year is not 2023.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalOptionsOfSpouseIsUndefinedWhenIsMarriedTrue]: {
    i18n: {
      fr: 'L\'objet des options de l\'époux n\'est pas définie alors que la personne principale est mariée.',
      en: 'The object of the spouse\'s options is not defined while the main person is married.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalAtLeastTwoChildrenWithSameId]: {
    i18n: {
      fr: 'Au moins deux enfants possèdent le même identifiant.',
      en: 'At least two children have the same ID.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalAtLeastOneChildWithAtLeastTwoChildrenWithSameId]: {
    i18n: {
      fr: 'Au moins deux enfants possèdent le même identifiant.',
      en: 'At least two children have the same ID.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalMainPersonAndSpouseHaveSameID]: {
    i18n: {
      fr: 'Les deux époux ont le même identifiant.',
      en: 'Spouses have the same ID.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalAtLeastTwoCampsWithSameId]: {
    i18n: {
      fr: 'Il y a au moins deux camps avec le même identifiant.',
      en: 'There are at least two camps with the same ID.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalChildHasAtLeastTwoCampsWithSameId]: {
    i18n: {
      fr: 'Cet enfant a au moins deux camps avec le même identifiant.',
      en: 'This child has at least two camps with the same ID.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalAtLeastOneChildWithAtLeastTwoCampsWithSameId]: {
    i18n: {
      fr: 'Il y a au moins un enfant avec au moins deux camps avec le même identifiant.',
      en: 'There is at least one child with at least two camps with the same ID.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalChildMissingCampIdInResults]: {
    i18n: {
      fr: 'L\'identifiant du camp ne fait pas partie des camps dans l\'objet résultat.',
      en: 'The camp\'s ID is not part of the result object.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalMissingChildIdInResults]: {
    i18n: {
      fr: 'L\'identifiant de l\'enfant ne fait pas partie des enfants dans l\'objet résultat.',
      en: 'The child\'s ID is not part of the result object.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalCareExpensesIsUndefinedForChild]: {
    i18n: {
      fr: 'Le montant de frais de garde est indéfini pour cet enfant.',
      en: 'The amount of childcare expenses is undefined for this child.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalOptionsOfFederalForMainPersonIsUndefined]: {
    i18n: {
      fr: 'L\'objet Options Federal de la personne principale n\'est pas défini dans le calcul d\'impôt personnel fédéral.',
      en: 'The object Options Federal of Main Person is undefined in the federal personal income tax calculation.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalOptionsOfFederalForSpouseIsUndefined]: {
    i18n: {
      fr: 'L\'objet Options Federal du conjoint n\'est pas défini dans le calcul d\'impôt personnel fédéral.',
      en: 'The object Options Federal of Spouse is undefined in the federal personal income tax calculation.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalOptionsOfFederalForAChildIsUndefined]: {
    i18n: {
      fr: 'L\'objet Options Federal d\'un enfant n\'est pas défini dans le calcul d\'impôt personnel fédéral.',
      en: 'The object Options Federal of a Child is undefined in the federal personal income tax calculation.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecOptionsOfSpouseIsUndefinedWhenIsMarriedTrue]: {
    i18n: {
      fr: 'L\'objet des options de l\'époux n\'est pas définie alors que la personne principale est mariée.',
      en: 'The object of the spouse\'s options is not defined while the main person is married.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecAtLeastTwoChildrenWithSameId]: {
    i18n: {
      fr: 'Au moins deux enfants possèdent le même identifiant alors que chaque enfant doit avoir un identifiant unique.',
      en: 'At least two children have the same ID but each child should have a unique identifier.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecAtLeastOneChildWithAtLeastTwoChildrenWithSameId]: {
    i18n: {
      fr: 'Au moins un enfant a le même identifiant qu\'au moins un autre enfant alors que chaque enfant doit avoir un identifiant unique.',
      en: 'At least one child has the same ID as at least one other child but each child should have a unique identifier.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecMainPersonAndSpouseHaveSameID]: {
    i18n: {
      fr: 'Les deux époux ont le même identifiant alors que chaque époux doit avoir un identifiant unique.',
      en: 'Spouses have the same ID and they cannot.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecAtLeastTwoCampsWithSameId]: {
    i18n: {
      fr: 'Il y a au moins deux camps avec le même identifiant alors que chaque camp doit avoir un identifiant unique.',
      en: 'There are at least two camps with the same ID but each camp should have a unique identifier.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecChildHasAtLeastTwoCampsWithSameId]: {
    i18n: {
      fr: 'Cet enfant a au moins deux camps avec le même identifiant alors que chaque camp doit avoir un identifiant unique.',
      en: 'This child has at least two camps with the same ID but each camp should have a unique identifier.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecAtLeastOneChildWithAtLeastTwoCampsWithSameId]: {
    i18n: {
      fr: 'Il y a au moins un enfant avec au moins deux camps avec le même identifiant.',
      en: 'There is at least one child with at least two camps with the same ID.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecChildMissingCampIdInResults]: {
    i18n: {
      fr: 'L\'identifiant du camp ne fait pas partie des camps dans l\'objet résultat.',
      en: 'The camp\'s ID is not part of the result object.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecMissingChildIdInResults]: {
    i18n: {
      fr: 'L\'identifiant de l\'enfant ne fait pas partie des enfants dans l\'objet résultat.',
      en: 'The child\'s ID is not part of the result object.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecCareExpensesIsUndefinedForChild]: {
    i18n: {
      fr: 'Le montant de frais de garde est indéfini pour cet enfant.',
      en: 'The amount of childcare expenses is undefined for this child.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecSpouseResultsUndefined]: {
    i18n: {
      fr: 'L\'objet résultats de l\'autre conjoint n\'est pas défini,',
      en: 'The object Results of the other spouse is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecOptionsOfQuebecForMainPersonIsUndefined]: {
    i18n: {
      fr: 'L\'objet Options Quebec de la personne principale n\'est pas défini dans le calcul d\'impôt personnel Quebec.',
      en: 'The object Options Quebec of Main Person is undefined in the Quebec personal income tax calculation.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecOptionsOfQuebecForSpouseIsUndefined]: {
    i18n: {
      fr: 'L\'objet Options Quebec du conjoint n\'est pas défini dans le calcul d\'impôt personnel Quebec.',
      en: 'The object Options Quebec of Spouse is undefined in the Quebec personal income tax calculation.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecOptionsOfFederalInQuebecForMainPersonIsUndefined]: {
    i18n: {
      fr: 'L\'objet Options Income Tax Person Federal dans Options Quebec de la personne principale n\'est pas défini dans le calcul d\'impôt personnel Quebec.',
      en: 'The object Options Income Tax Person Federal in Options Quebec of Main Person is undefined in the Quebec personal income tax calculation.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecOptionsOfFederalInQuebecForSpouseIsUndefined]: {
    i18n: {
      fr: 'L\'objet Options Income Tax Person Federal dans Options Quebec du conjoint n\'est pas défini dans le calcul d\'impôt personnel Quebec.',
      en: 'The object Options Income Tax Person Federal in Options Quebec of Spouse is undefined in the Quebec personal income tax calculation.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecOptionsOfQuebecForAChildIsUndefined]: {
    i18n: {
      fr: 'L\'objet Options Quebec d\'un enfant n\'est pas défini dans le calcul d\'impôt personnel Quebec.',
      en: 'The object Options Quebec of a Child is undefined in the Quebec personal income tax calculation.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalOptionsAreUndefinedForSingle]: {
    i18n: {
      fr: 'Les options fédérales pour le calcul de l\'impôt sur le revenu des personnes physiques pour 2021 lorsque la personne principale est célibataire ne sont pas définies.',
      en: 'The federal options to calculate the personal income tax for 2021 when main person is single are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalResultsForSchedule8InSalaryContributionsAreUndefinedForSingle]: {
    i18n: {
      fr: 'Les résultats de l\'annexe 8 pour le calcul des cotisations salariales pour l\'impôt sur le revenu personnel de 2021 lorsque la personne principale est célibataire ne sont pas définis.',
      en: 'The results for schedule 8 to calculate the salary contributions for the personal income tax of 2021 when main person is single are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalResultsForSchedule10InSalaryContributionsAreUndefinedForSingle]: {
    i18n: {
      fr: 'Les résultats de l\'annexe 10 pour le calcul des cotisations salariales pour l\'impôt sur le revenu personnel de 2021 lorsque la personne principale est célibataire ne sont pas définis.',
      en: 'The results for schedule 10 to calculate the salary contributions for the personal income tax of 2021 when main person is single are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalResultsForScheduleRInSalaryContributionsAreUndefinedForSingle]: {
    i18n: {
      fr: 'Les résultats de l\'annexe R pour le calcul des cotisations salariales pour l\'impôt sur le revenu personnel de 2021 lorsque la personne principale est célibataire ne sont pas définis.',
      en: 'The results for schedule R to calculate the salary contributions for the personal income tax of 2021 when main person is single are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecOptionsAreUndefinedForSingle]: {
    i18n: {
      fr: 'Les options Quebec pour le calcul de l\'impôt sur le revenu des personnes physiques pour 2021 lorsque la personne principale est célibataire ne sont pas définies.',
      en: 'The Quebec options to calculate the personal income tax for 2021 when main person is single are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalOptionsMainPersonAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les options fédérales de la personne principale pour le calcul de l\'impôt sur le revenu des personnes physiques pour 2021 lorsque la personne principale est mariée ne sont pas définies.',
      en: 'The federal options of main person to calculate the personal income tax for 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalResultsMainPersonForSchedule8InSalaryContributionsAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les résultats de l\'annexe 8 de la personne principale pour le calcul des cotisations salariales pour l\'impôt sur le revenu personnel de 2021 lorsque la personne principale est mariée ne sont pas définis.',
      en: 'The results of main person for schedule 8 to calculate the salary contributions for the personal income tax of 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalResultsMainPersonForSchedule10InSalaryContributionsAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les résultats de l\'annexe 10 de la personne principale pour le calcul des cotisations salariales pour l\'impôt sur le revenu personnel de 2021 lorsque la personne principale est mariée ne sont pas définis.',
      en: 'The results of main person for schedule 10 to calculate the salary contributions for the personal income tax of 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalResultsMainPersonForScheduleRInSalaryContributionsAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les résultats de l\'annexe R de la personne principale pour le calcul des cotisations salariales pour l\'impôt sur le revenu personnel de 2021 lorsque la personne principale est mariée ne sont pas définis.',
      en: 'The results of main person for schedule R to calculate the salary contributions for the personal income tax of 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecOptionsMainPersonAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les options Quebec de la personne principale pour le calcul de l\'impôt sur le revenu des personnes physiques pour 2021 lorsque la personne principale est mariée ne sont pas définies.',
      en: 'The Quebec options of main person to calculate the personal income tax for 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalSpouseOptionsAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les options du conjoint pour le calcul de l\'impôt sur le revenu des personnes physiques pour 2021 lorsque la personne principale est mariée ne sont pas définies.',
      en: 'The spouse options to calculate the personal income tax for 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalOptionsSpouseAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les options fédérales du conjoint pour le calcul de l\'impôt sur le revenu des personnes physiques pour 2021 lorsque la personne principale est mariée ne sont pas définies.',
      en: 'The federal options of spouse to calculate the personal income tax for 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalResultsSpouseForSchedule8InSalaryContributionsAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les résultats de l\'annexe 8 du conjoint pour le calcul des cotisations salariales pour l\'impôt sur le revenu personnel de 2021 lorsque la personne principale est mariée ne sont pas définis.',
      en: 'The results of spouse for schedule 8 to calculate the salary contributions for the personal income tax of 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalResultsSpouseForSchedule10InSalaryContributionsAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les résultats de l\'annexe 10 du conjoint principale pour le calcul des cotisations salariales pour l\'impôt sur le revenu personnel de 2021 lorsque la personne principale est mariée ne sont pas définis.',
      en: 'The results of spouse for schedule 10 to calculate the salary contributions for the personal income tax of 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalResultsSpouseForScheduleRInSalaryContributionsAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les résultats de l\'annexe R du conjoint pour le calcul des cotisations salariales pour l\'impôt sur le revenu personnel de 2021 lorsque la personne principale est mariée ne sont pas définis.',
      en: 'The results of spouse for schedule R to calculate the salary contributions for the personal income tax of 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecOptionsSpouseAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les options Quebec du conjoint pour le calcul de l\'impôt sur le revenu personnel pour 2021 lorsque la personne principale est mariée ne sont pas définies.',
      en: 'The Quebec options of spouse to calculate the personal income tax for 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalFederalResultsForSpouseAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les résultats fédéraux du conjoint pour le calcul de l\'impot federal sur le revenu personnel pour 2021 lorsque la personne principale est mariée ne sont pas définis.',
      en: 'The federal results of spouse to calculate the personal income tax for 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalQuebecResultsForSpouseAreUndefinedForMarried]: {
    i18n: {
      fr: 'Les résultats Quebec du conjoint pour le calcul de l\'impôt sur le revenu personnel pour 2021 lorsque la personne principale est mariée ne sont pas définies.',
      en: 'The Quebec results of spouse to calculate the personal income tax for 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalSpouseOptionsAreUndefinedForSalaryContributions]: {
    i18n: {
      fr: 'Les options du conjoint pour le calcul de cotisations salariales pour l\'impôt sur le revenu personnel pour 2021 lorsque la personne principale est mariée ne sont pas définies.',
      en: 'The options of spouse to calculate salary contributions for the personal income tax for 2021 when main person is married are undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalAtLeastTwoChildrenWithSameId]: {
    i18n: {
      fr: 'Au moins deux enfants possèdent le même identifiant alors que chaque enfant doit avoir un identifiant unique.',
      en: 'At least two children have the same ID but each child should have a unique identifier.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalAtLeastOneChildWithAtLeastTwoChildrenWithSameId]: {
    i18n: {
      fr: 'Au moins un enfant a le même identifiant qu\'au moins un autre enfant alors que chaque enfant doit avoir un identifiant unique.',
      en: 'At least one child has the same ID as at least one other child but each child should have a unique identifier.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalAtLeastTwoCampsWithSameId]: {
    i18n: {
      fr: 'Il y a au moins deux camps avec le même identifiant alors que chaque camp doit avoir un identifiant unique.',
      en: 'There are at least two camps with the same ID but each camp should have a unique identifier.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalChildHasAtLeastTwoCampsWithSameId]: {
    i18n: {
      fr: 'Cet enfant a au moins deux camps avec le même identifiant alors que chaque camp doit avoir un identifiant unique.',
      en: 'This child has at least two camps with the same ID but each camp should have a unique identifier.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalAtLeastOneChildWithAtLeastTwoCampsWithSameId]: {
    i18n: {
      fr: 'Il y a au moins un enfant avec au moins deux camps avec le même identifiant.',
      en: 'There is at least one child with at least two camps with the same ID.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxPersonalMissingChildIdInResults]: {
    i18n: {
      fr: 'L\'identifiant de l\'enfant ne fait pas partie des enfants dans l\'objet résultat.',
      en: 'The child\'s ID is not part of the result object.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxCorporateFederalOptionsFederalUndefined]: {
    i18n: {
      fr: 'L\'objet Options Federal n\'est pas défini,',
      en: 'The object Options Federal is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxCorporateQuebecOptionsQuebecUndefined]: {
    i18n: {
      fr: 'L\'objet Options Quebec n\'est pas défini dans le calcul d\'impôt.',
      en: 'The object Options Quebec is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.IncomeTaxCorporateFederalOptionsInSalaryDividendCalculationIsUndefined]: {
    i18n: {
      fr: 'Les options de l\'impôt fédéral sur les sociétés dans le calcul du salaire dividende n\'est pas définie.',
      en: 'The federal corporate income tax options in the salary dividend calculation is undefined.',
    },
  },
  [CalculationErrorKeynameEnum.SalaryDividendSimulationDoesNotGenerateASingleNonNullResult]: {
    i18n: {
      fr: 'Le calcul salaire-dividende simulation ne génère aucun scénario valide, peu importe le pourcentage.',
      en: 'The salary-dividend simulation calculation does not generate a valid scenario, regardless of the percentage.',
    },
  },
  [CalculationErrorKeynameEnum.SalaryContributionsTotalPayrollUndefinedWhenShouldFSSBeCalculatedIsTrue]: {
    i18n: {
      fr: 'Dans le calcul, si la cotisation au Fonds des services de santé (FSS) doit être calculé, la masse salariale totale doit être fournie.',
      en: 'In the calculation, if the Health Services Fund should be calculated, the total payroll must be specified.',
    },
  },
  [CalculationErrorKeynameEnum.SalaryContributionsIsEmployerFromPublicSectorWhenShouldFSSBeCalculatedIsTrue]: {
    i18n: {
      fr: 'Dans le calcul, si la cotisation au Fonds des services de santé (FSS) doit être calculé, il faut spécifie si l\'employeur est du secteur public ou non.',
      en: 'In the calculation, if the Health Services Fund should be calculated, if the employer is from public sector or not must be specified..',
    },
  },
  [CalculationErrorKeynameEnum.Schedule8DeathdateMustBeSpecifiedWhenTaxpayerIsDead]: {
    i18n: {
      fr: 'Dans le calcul, la date du décès du contribuable doit être spécifié si le contribuable est décédé.',
      en: 'In the calculation, the taxpayer\'s death date must be specified if the taxpayer passed away.',
    },
  },


};